define((require) => {
    "use strict";

    var ImprovedView      = require("editor/zbone/ImprovedView"),
        listTemplate      = require("editor/ui/settings/integrations/customJs/lockIcon/CustomJsLockIconList.tpl"),
        template          = require("editor/ui/settings/integrations/customJs/lockIcon/CustomJsLockIconView.tpl"),
        Tooltip           = require("ui/common/Tooltip");

    return ImprovedView.extend({
        template: template,

        ui: {
            lockIcon: ".lock-icon"
        },

        tagName: "span",

        className: "custom-js-lock-container",

        onRender: function() {
            var experiences = this.viewScope.experiences();

            Tooltip.add(this.ui.lockIcon, {
                trigger: "dropdown",
                placement: "top",
                container: this.$el,
                width: 250,
                html: true,
                classes: "custom-js-lock-list",
                duration: 0,
                content: listTemplate({
                    // Get experiences from ids
                    experiences: this.options.ids.map(experiences.get.bind(experiences))
                })
            });
        },

        onClose: function() {
            Tooltip.remove(this.ui.lockIcon);
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/integrations/customJs/lockIcon/CustomJsLockIconView.js